import { List as ListAntd } from "antd";
import styled from "styled-components";

const List = styled(ListAntd)`
  .ant-list-items {
    height: ${({ height }) => height};
    padding-right: 1rem;
    overflow: hidden auto;
  }
  .ant-empty {
    height: ${({ height }) => height};
  }
`;

List.Item = styled(ListAntd.Item)``;

List.Item.Meta = styled(ListAntd.Item.Meta)`
  .ant-list-item-meta-description {
    font-size: 0.75rem;
    line-height: 14px;
  }
`;

export default { List };
